import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";


export default function isArea(str, responseText) {
    const regVal = regexList.area.pattern;
    return regexTest(str, regVal, responseText) || regexList.area.response;
}